import { render, staticRenderFns } from "./UpdatePositionConfirmationDialog.vue?vue&type=template&id=789957b0&scoped=true&"
import script from "./UpdatePositionConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePositionConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePositionConfirmationDialog.vue?vue&type=style&index=0&id=789957b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789957b0",
  null
  
)

export default component.exports